import type { BusinessTab } from '../../router';
import type { Go } from './steps';

/**
 * How an Overview action gets the operator to where the thing is done: a tab
 * of this page, or Checks & imports. The page supplies both moves, so a link
 * here is the same address change the tab bar makes — back returns to the
 * Overview.
 */
export interface Moves {
  onTab: (tab: BusinessTab) => void;
  onChecks: () => void;
}

export function follow(moves: Moves, go: Go): void {
  if (go.kind === 'tab') moves.onTab(go.tab);
  else moves.onChecks();
}
